import { Component, ViewChild } from '@angular/core';
import { JkReportComponent } from './jkReport';
import { PageKind } from 'jk-service';


@Component({
  template: ''
})
export class JkBatchComponent extends JkReportComponent {

  constructor() {
    super();
    this.pageKind = PageKind.batch;
  }
  override ngOnInit() {
    super.ngOnInit();
    this.getLookup();
  }

}
